var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container",class:{
            paddingBottom: _vm.$store.state.User.iphonex,
            hasTabPaddingBottom: _vm.$store.state.User.iphonex,
            iosmargin: _vm.$store.state.User.ios && _vm.isFull,
            iphonexmargin: _vm.$store.state.User.iphonex && _vm.isFull
        }},[(_vm.$route.meta.nokeepAlive)?_c('router-view',{ref:"contenterbody"}):_c('keep-alive',[_c('router-view',{ref:"contenterbody"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }